import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface TopbarContextType {
  subtitle: string | undefined;
  setSubtitle: (subtitle: string | undefined) => void;
  titleOverride: string | undefined;
  setTitleOverride: (title: string | undefined) => void;
  rightActions: ReactNode;
  setRightActions: (node: ReactNode) => void;
}

const TopbarContext = createContext<TopbarContextType | undefined>(undefined);

export const TopbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
  const [titleOverride, setTitleOverride] = useState<string | undefined>(undefined);
  const [rightActions, setRightActions] = useState<ReactNode>(null);

  const value = useMemo(
    () => ({ subtitle, setSubtitle, titleOverride, setTitleOverride, rightActions, setRightActions }),
    [subtitle, titleOverride, rightActions]
  );

  return (
    <TopbarContext.Provider value={value}>
      {children}
    </TopbarContext.Provider>
  );
};

export const useTopbar = () => {
  const context = useContext(TopbarContext);
  if (!context) {
    throw new Error('useTopbar must be used within a TopbarProvider');
  }
  return context;
};

